import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Package, Wrench } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { BRANCHES, fmtDate, fmtDateTime } from "@/lib/format";

export const EventCard = ({ ev, i = 0 }) => (
  <Link to={`/evento/${ev.id}`} data-testid={`event-card-${ev.id}`} style={{ animationDelay: `${i * 60}ms` }}
    className="rise group grid gap-4 rounded-md border border-slate-800/80 bg-slate-900/60 p-5 transition-colors hover:border-amber-500/40 hover:bg-slate-900 sm:grid-cols-[110px_1fr_auto]">
    <div className="flex items-baseline gap-2 sm:block">
      <div className="font-display text-4xl font-extrabold leading-none text-amber-400">{fmtDate(ev.event_date, "dd")}</div>
      <div className="font-mono text-xs uppercase tracking-widest text-slate-400">{fmtDate(ev.event_date, "MMM yyyy")}</div>
    </div>
    <div className="min-w-0 space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <StatusBadge status={ev.status} testId={`event-card-status-${ev.id}`} />
        <span data-testid={`event-card-branch-${ev.id}`} className="rounded-sm border border-slate-700 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-slate-300">{BRANCHES[ev.branch]}</span>
        {ev.client && <span className="truncate text-xs text-slate-500">{ev.client}</span>}
      </div>
      <h3 className="font-display text-2xl font-bold leading-tight">{ev.title}</h3>
      <p className="flex items-center gap-1.5 text-sm text-slate-400"><MapPin size={14} className="shrink-0 text-amber-400" /><span className="truncate">{ev.location}</span></p>
      <div className="flex flex-wrap gap-x-5 gap-y-1 font-mono text-xs text-slate-400">
        <span className="flex items-center gap-1.5"><Wrench size={12} className="text-emerald-400" />Montagem {fmtDateTime(ev.setup_date, ev.setup_time)}</span>
        <span className="flex items-center gap-1.5"><Wrench size={12} className="rotate-180 text-indigo-400" />Desmontagem {fmtDateTime(ev.teardown_date, ev.teardown_time)}</span>
        <span className="flex items-center gap-1.5"><Package size={12} />{ev.equipment.reduce((s, e) => s + e.quantity, 0)} itens</span>
      </div>
    </div>
    <ArrowUpRight className="hidden text-slate-600 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-amber-400 sm:block" />
  </Link>
);
